import React, { useContext } from 'react'
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import { Container, Col, Row, Card } from "react-bootstrap";
import { ThemeContext } from "../theming";
import Logo4 from "../assets/images/logo4.png";
import useWindowDimensions from '../helpers/useWindowDimensions';
import { TextColored } from '../components/typography';
import { WEB_PROGRESO } from "../helpers/url";
import CustomButton from '../components/buttons/Button';

function Error() {
    const { width } = useWindowDimensions();

    const container = {
        width: '100%',
        height: '100%',
        padding: '20px'
    };

    const containerMobile = {
        width: '100%',
        height: width >= 375 ? '100%' : '',
        background: 'white',
        padding: '20px',
    };

    const app = useContext(ThemeContext);
    const { body14, body25, body28, body32 } = app.theme.font;

    return (
        <>
            <section style={{ width: "100%" }}>
                <Header />
                <Container className="login-clientes justify-content-center" style={width >= 701 ? container : containerMobile} fluid>
                    <Col xs={9} lg={6} style={{ margin: "75px 0px" }}>
                        <Row>
                            <Card style={{
                                backgroundColor: "white",
                                width: "100%",
                                height: "380px",
                            }}>
                                <Row className="mt-4 justify-content-center">
                                    <img style={{ width: "96px" }} alt="" src={Logo4} />
                                </Row>
                                <Row className="justify-content-center py-2">
                                    <TextColored size={body32} bold={true} >
                                        Hmmm...
                                    </TextColored>
                                </Row>
                                <Row className="mt-3">
                                    <TextColored size={body14}>
                                       Al parecer estás perdido, permítenos guiarte en tu travesía.
                                    </TextColored>
                                </Row>
                                <Row className="mt-4 justify-content-center" xs={2} sm={3}>
                                    <Col>
                                        <a href={WEB_PROGRESO}>
                                            <CustomButton size={body14} sizeText={1}>
                                                Volver al inicio
                                            </CustomButton>
                                        </a>
                                    </Col>
                                </Row>
                            </Card>
                        </Row>
                    </Col>
                </Container>
                <Footer margin={false} />
            </section>
        </>
    )
}

export default Error